// extracted by mini-css-extract-plugin
export var bodyRow = "_el-d";
export var cardColumns = "_el-e";
export var ellipsesOverflow = "_el-2";
export var flatBottomCorners = "_el-3";
export var flatTopCorners = "_el-4";
export var headerActionsDropdown = "_el-f";
export var headerBottomRow = "_el-c";
export var headerTopRow = "_el-b";
export var orderDetailsWrapper = "_el-0";
export var orderInfoContainer = "_el-1";
export var productDetails = "_el-9";
export var productImage = "_el-5";
export var responsiveTable = "_el-8";
export var shipmentContainer = "_el-a";
export var tableBottomLeft = "_el-6";
export var tableBottomRight = "_el-7";